module.exports = __webpack_public_path__ + "static/media/labor.19a3db54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/labor.svg
// module id = 648
// module chunks = 36